import React from 'react';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { TestId, pillToLoadingTextI18n, DialogPillName } from './dialogConstants.tsx';
import * as S from './analyticsDialogStyled.tsx';
import { AnalyticsDialogHeader } from './Header/Header.tsx';
import { AnalyticsDialogInfoPanel } from './InfoPanel/AnalyticsDialogInfoPanel.tsx';
import { AnalyticsDialogFooter } from './Footer/Footer.tsx';
import { AnalyticsDialogUserList } from './UserList/UserList.tsx';

type AnalyticsDialogSsrProps = {
	zIndex: number;
};

const marginBottomStyles = xcss({ marginBottom: 'space.200' });

export const AnalyticsDialogSsr: FC<AnalyticsDialogSsrProps> = ({ zIndex }) => {
	const { edition } = useSessionData();
	const shouldShowMentions = edition === 'PREMIUM';

	return (
		<S.SSRContainer zIndex={zIndex} data-testid={TestId.DIALOG_SKELETON}>
			<S.Container role="dialog">
				<AnalyticsDialogHeader
					isLoading
					shouldShowPills={shouldShowMentions}
					selectedPill={DialogPillName.VIEWS}
				/>
				<AnalyticsDialogInfoPanel isLoading viewsCount={0} uniqueViewsCount={0} />
				<Box xcss={marginBottomStyles}>
					<S.SSRChartSkeleton />
				</Box>
				<S.SSRLoadingText>
					<FormattedMessage {...pillToLoadingTextI18n[DialogPillName.VIEWS]} />
				</S.SSRLoadingText>
				{shouldShowMentions && (
					<Box xcss={marginBottomStyles}>
						<AnalyticsDialogUserList accounts={[]} isLoading />
					</Box>
				)}
				<AnalyticsDialogFooter isLoading contentId="" />
			</S.Container>
		</S.SSRContainer>
	);
};
